import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';

import SidebarElementSpacing from './SidebarElementSpacing.js';
import BorderPicker from './BorderPicker.js';

import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';
import Slider, { Range } from 'rc-slider';

import SidebarElementHeader from './SidebarElementHeader.js';

class Divider extends React.Component {
	constructor(props) {	
		super(props);
		this.el = this.el.bind(this);	
		this.handleBackClick = this.handleBackClick.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onPaddingBottomChange = this.onPaddingBottomChange.bind(this);
		this.onPaddingTopChange = this.onPaddingTopChange.bind(this);
		
	}

	handleChange(id,s) {
		let changes = {};
    	changes[id] = s; 
		this.props.setComponentState(this.el().id,changes);
	}

    el() {
    	return this.props.builder.components[this.props.id];
    }

    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }

   
    

	componentDidMount() {
		
	}

	onChange(v) {
    	this.props.setComponentState(this.el().id,{width:v+'%'});
    }

    onPaddingTopChange(v) {
    	this.props.setComponentState(this.el().id,{paddingTop:v+'px'});
    }

    onPaddingBottomChange(v) {
    	this.props.setComponentState(this.el().id,{paddingBottom:v+'px'});
    }

    render() {
    	
    	if(this.props.sidebar == true) {
    		return(
	    		<div className="sidebar text" style={this.props.style}>

	    			<SidebarElementHeader handleBackClick={this.handleBackClick} text="Divider" />
	    			<div className="panel-group panel-group-continuous" id="divider-settings" aria-multiselectable="true" role="tablist">

	    				<SidebarSettingAccordion selectedSetting={false} optionKey="divider" parent="divider-settings" title="Divider">
	    					<SidebarElementSetting text="Divider">
	                            <BorderPicker id='border_top' handleBorderChange={this.handleChange} data={this.el().border_top}  />
							</SidebarElementSetting>
		    			
		    				<SidebarElementSetting text="Width">
								
		    				<Slider value={parseInt(this.el().width.replace('%',''))}
						        onChange={this.onChange} 
									min={5}
									max={100}
						      />
							</SidebarElementSetting>
	    				</SidebarSettingAccordion>


            			<SidebarSettingAccordion selectedSetting={false} optionKey="spacing" parent="divider-settings" title="Spacing">
            				<SidebarElementSetting text="Spacing top">
	            				<Slider
								value={parseInt(this.el().paddingTop.replace('px',''))}
								onChange={this.onPaddingTopChange} 

									min={5}
									max={100}
								/>
							</SidebarElementSetting>

							<SidebarElementSetting text="Spacing bottom">
								<Slider
									value={parseInt(this.el().paddingBottom.replace('px',''))}
									onChange={this.onPaddingBottomChange} 
									min={5}
									max={100}
								/>
							</SidebarElementSetting>
            			</SidebarSettingAccordion>

            		</div>
	    		</div>


    		);
    	}else{

    		return (
    			<table className="table-block" style={{width:'100%'}}>
    				<tbody>
    					<tr>
	    					<td style={{paddingBottom:this.el().paddingBottom,paddingTop:this.el().paddingTop}}>
	    						<table style={{margin: "0 auto",borderTop:this.el().border_top.replace(/\|/g,' '),width:this.el().width}}>
	    							<tbody>
	    								<tr><td><span></span></td></tr>
	    							</tbody>
	    						</table>
	    					</td>
    					</tr>
    				</tbody>
    			</table>
	      		
	      );
    	}
      
    }
}
const mapStateToProps = (state) => {
	return {
		builder:state.builder
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

Divider = connect(mapStateToProps,mapDispatchToProps)(Divider);

export default Divider;





// WEBPACK FOOTER //
// ./components/builder/Divider.js